import {
  ActionIcon,
  Button,
  Flex,
  Group,
  Menu,
  Select,
  Stack,
  Table,
  Text,
  TextInput,
  ThemeIcon,
  Title,
} from '@mantine/core'
import classes from './AdminSettings.module.css'
import { IconDots, IconGripVertical } from '@tabler/icons-react'
import { useEffect } from 'react'
import { modals } from '@mantine/modals'
import { useNavigate } from 'react-router-dom'

// TODO: ADD TYPES TO BLUECARD-TYPES
enum DispositionTypes {
  ANSWERED = 'Answered',
  NOT_ANSWERED = 'Not answered',
}

export const CallsDispositionsAdd = () => {
  const navigate = useNavigate()

  const handleCancel = () => {
    modals.closeAll()
    navigate('..')
  }

  const types = Object.entries(DispositionTypes).map(([key, val]) => ({
    label: val,
    value: key,
  }))

  useEffect(() => {
    modals.openConfirmModal({
      modalId: 'CallsDispositionAdd',
      title: <Title order={3}>Add call disposition</Title>,
      children: (
        <Stack>
          <TextInput size="md" label="Call disposition" withAsterisk />
          <Select size="md" label="Type" data={types} placeholder="Select" />
        </Stack>
      ),
      labels: { confirm: 'Confirm', cancel: 'Cancel' },
      onCancel: handleCancel,
      onConfirm: () => console.log('Confirmed'),
    })
  })

  return <></>
}
